import { gql } from '@apollo/client';

export const GET_STRIPE_SUPPORTED_CURRENCIES = gql`
  query FetchStripeSupportedCurrencies {
    fetchStripeSupportedCurrencies
  }
`;

export const CONNECT_FRESHBOOKS = gql`
  query connectFreshbooksQuery($code: String!) {
    connectFreshbooks(code: $code) {
      freshbooks
    }
  }
`;

export const CONNECT_QUICKBOOKS = gql`
  query connectQuickBooksMutation($url: String!) {
    connectQuickBooks(url: $url)
  }
`;

export const CONNECT_MONDAY = gql`
  query connectMondayMutation($url: String!) {
    connectMonday(url: $url) {
      token
      user {
        _id
        profile {
          language
          currency
        }
        monday
      }
    }
  }
`;

export const CONNECT_HUBSPOT = gql`
  query connectHubspotMutation($url: String!) {
    connectHubspot(url: $url) {
      token
      user {
        _id
        profile {
          language
          currency
        }
        hubspot {
          token {
            expires_in
          }
          account {
            id
            roleIds
            superAdmin
          }
          updatedAt
        }
      }
      state
    }
  }
`;

export const FETCH_MONDAY_CONTACTS = gql`
  query fetchMondayContacts($boardId: String!) {
    fetchMondayContacts(boardId: $boardId)
  }
`;

export const FETCH_HUBSPOT_CONTACTS = gql`
  query fetchHubSpotContacts($after: String) {
    fetchHubSpotContacts(after: $after)
  }
`;

export const SEARCH_HUBSPOT_CONTACTS = gql`
  query searchHubSpotContacts($query: String!, $after: String, $limit: Float) {
    searchHubSpotContacts(query: $query, after: $after, limit: $limit)
  }
`;

export const FETCH_HUBSPOT_DEAL_BY_ID = gql`
  query fetchHubSpotDealById($proposalId: String!) {
    fetchHubSpotDealById(proposalId: $proposalId)
  }
`;

export const FETCH_HUBSPOT_COMPANY_BY_ID = gql`
  query fetchHubSpotCompanyById($proposalId: String!) {
    fetchHubSpotCompanyById(proposalId: $proposalId)
  }
`;

export const CONNECT_XERO = gql`
  query connectXeroQuery($url: String!) {
    connectXero(url: $url) {
      token
      user {
        _id
        profile {
          language
          currency
          terms
          name
        }
        xero
        ptype
      }
    }
  }
`;

export const FETCH_XERO_ACCOUNTS = gql`
  query fetchXeroAccounts($tenantId: String!) {
    fetchXeroAccounts(tenantId: $tenantId)
  }
`;

export const CONNECT_SLACK = gql`
  query connectSlackQuery($code: String!) {
    connectSlack(code: $code)
  }
`;

export const CONNECT_PIPEDRIVE = gql`
  query connectPipedriveMutation($code: String!) {
    connectPipedrive(code: $code)
  }
`;

export const FETCH_PIPEDRIVE_CONTACTS = gql`
  query FetchPipedriveContacts($cursor: String, $limit: Float) {
    fetchPipedriveContacts(cursor: $cursor, limit: $limit) {
      contacts {
        id
        name
        email
      }
      nextCursor
    }
  }
`;

export const FETCH_PIPEDRIVE_DEALS = gql`
  query FetchPipedriveDeals($cursor: String, $limit: Float) {
    fetchPipedriveDeals(cursor: $cursor, limit: $limit) {
      deals {
        id
        title
      }
      nextCursor
    }
  }
`;

export const FETCH_PIPEDRIVE_PRODUCTS = gql`
  query FetchPipedriveProducts($cursor: String, $limit: Float) {
    fetchPipedriveProducts(cursor: $cursor, limit: $limit) {
      products {
        id
        name
        description
        tax
        price {
          amount
          items
        }
      }
      nextCursor
      limit
    }
  }
`;

export const FETCH_HUBSPOT_PRODUCTS = gql`
  query FetchHubSpotProducts($cursor: String, $limit: Float) {
    fetchHubSpotProducts(cursor: $cursor, limit: $limit) {
      products {
        id
        name
        description
        price {
          amount
          type
          items
        }
        discount {
          value
          unit
        }
        images {
          url
        }
      }
      nextCursor
      limit
    }
  }
`;

export const FETCH_PIPEDRIVE_DEALS_CLIENT_DETAILS = gql`
  query FetchPipedriveDealsClientDetails(
    $pipedriveSelectedId: String!
    $pipedriveResource: String!
  ) {
    fetchPipedriveDealsClientDetails(
      pipedriveSelectedId: $pipedriveSelectedId
      pipedriveResource: $pipedriveResource
    ) {
      dealClientName
      dealClientEmail
      dealId
    }
  }
`;

export const REFRESH_PROPOSAL_PIPEDRIVE_DEAL = gql`
  query RefreshProposalPipedriveDeal($proposalId: String!) {
    refreshProposalPipedriveDeal(proposalId: $proposalId) {
      _id
      pid
      uid
      auid
      pnum
      name
      state
      channel
      draft
      email
      edited
      isSecured
      sharePasswordOverEmail
      password
      client {
        contact
        name
        desc
        address
        text
        email
      }
      seenTime
      seenCount
      lastSeen
      emailLogs {
        date
        recipient
        type
        event
      }
      openLogs {
        date
        clientIP
        duration
        watched
        pageTime
        deviceInfo {
          deviceType
          deviceOS
          deviceBrowser
          deviceName
          deviceAgent
        }
      }
      date
      project {
        name
        type
        othertype
        name
        desc
        goals
      }
      approvedmanually
      version
      sawyou
      pricing
      deliverables
      milestones
      sawmilestones
      superPowers
      curr
      priceSeperator
      lockedData
      decimalPrecision
      language
      expiryDate
      expiryMessage
      currency
      callButton
      contactButton
      contactnumber
      enablePayment
      clientPayableAmount
      clientPayableLabel
      clientPayableCurrency
      clientPayableLink
      editEvent
      enableAITool
      userway
      creatorUserway
      scripts
      chatway
      chatwayScripts
      stripe
      payment {
        status
        amount
        currency
        payment_intend
        created
      }
      published
      disableSig
      signatureEmails
      selectedOption
      prevState
      payedfor
      dateFormat
      redirectTo
      redirectAfter
      proposalRedirectAfter
      proposalRedirectTo
      sigOptions
      contactOptions {
        option
        value
        enabled
      }
      sigtype
      signature {
        name
        myname
        additionalSignature
        signatureBackgroundColor
        signatureTextColor
        additionalSignatureBackgroundColor
        additionalSignatureTextColor
        email
        date
        clientIP
        device
      }
      attachments {
        name
        type
        url
        size
      }
      isEditing {
        name
        uid
        tabID
      }
      importedProposal
      spamUrls {
        url
        blocked
      }
      wixConnectedInstance
      fromUserTemplate
      isBasicTemplate
      wixProposalId
      wixPricing {
        lineItems {
          quantity
          name
          description
          price
          pricesBreakdown {
            totalPriceAfterTax
            taxDetails {
              taxRate
              taxableAmount
              taxable
              totalTax
              taxName
              rateBreakdown {
                rate
                taxableAmount
                tax
              }
            }
            totalDiscount
            price
            priceBeforeDiscounts
            lineItemPrice
            fullPrice
          }
          itemType {
            preset
          }
        }
        appliedDiscounts {
          discountType
          lineItemIds
        }
        additionalFees {
          name
          priceBeforeTax
          taxDetails {
            taxRate
            taxableAmount
            taxable
            totalTax
            taxName
            rateBreakdown {
              rate
              taxableAmount
              tax
            }
          }
          price
        }
        calculatedTotals {
          priceSummary {
            total
            subtotal
            discount
            additionalFees
          }
        }
        paymentSettings {
          type
          singlePaymentSchedule {
            dueDate
            dueDateOffset
            issueDate
            deposit {
              percentage
              amount
            }
            paymentStatus
            amountPaid
          }
          multiplePaymentSchedule {
            items {
              dueDate
              dueDateOffset
              issueDate
              deposit {
                percentage
                amount
              }
              issueDateOffset
              title
              percentage
              amount
              paymentStatus
              amountPaid
            }
          }
        }
        currencyCode
        locale {
          country
          language
        }
      }
      isWixTemplate
      fonts {
        family
        weights
        source
        title
        format
        url
      }
      fonts {
        family
        weights
        source
        title
        format
        url
      }
      sharedViaMail
      emailSettings {
        publishedProposalToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        reminderToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        secondReminderToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        signedPDFToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        recipients {
          firstName
          lastName
          email
        }
      }
      pipedriveDealId
    }
  }
`;

export const PERFORM_PIPEDRIVE_ACTIONS = gql`
  query PerformPipedriveActions(
    $pipedriveAction: String!
    $pipedriveUserId: String!
    $pipedriveProposalId: String!
    $pipedriveToken: String!
    $origin: String
  ) {
    performPipedriveActions(
      pipedriveAction: $pipedriveAction
      pipedriveUserId: $pipedriveUserId
      pipedriveProposalId: $pipedriveProposalId
      pipedriveToken: $pipedriveToken
      origin: $origin
    ) {
      id
      pdfLink
      success
      pid
    }
  }
`;
